/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillCustomers2} from '../api'

export const useMutationBackfillCustomers2 = createReactQueryMutationHook('backfillCustomers2', backfillCustomers2)
